import { BOTON_ENLACE } from "@/components/shared/estilos";

/**
 * El botón con aspecto de enlace de las pantallas de acceso, con el área
 * táctil mínima de 44 px: «¿Olvidaste la contraseña?», «Volver» o «Reenviar»
 * se tocan con el pulgar en un móvil y, como texto suelto, medían 20 px.
 */
export const ENLACE_TACTIL = [BOTON_ENLACE, "inline-flex min-h-11 items-center justify-center px-2"].join(" ");
